import type { DeleteLedgerAccountResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  zodDeleteLedgerAccountEndpointSchema,
  zodDeleteLedgerAccountResponseSchema,
} from './validations';

/**
 * Soft-deletes a ledger account's currently open version. Idempotent --
 * deleting an already-deleted account just returns its current state.
 *
 * @param ledgerAccountId - The ledger account's own id, stable across all of its versions.
 * @param options - Optional request options (e.g., abort signal).
 * @returns The soft-deleted ledger account version.
 * @throws VestigasHTTPError if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Ledger-Accounts/operation/delete_ledger_account_ledger_accounts__ledger_account_id__delete
 */
export const deleteLedgerAccount = async (
  ledgerAccountId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .delete(ENDPOINT.LEDGER_ACCOUNT.DELETE(ledgerAccountId), {
      ...options,
      validate: {
        ...options?.validate,
        pathSegments: zodDeleteLedgerAccountEndpointSchema,
        response: zodDeleteLedgerAccountResponseSchema,
      },
    })
    .json<DeleteLedgerAccountResponse>();
